"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiCheckboxFactory = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var downshift_1 = require("downshift");
var factory_1 = require("../internal/factory");
var units_1 = require("../internal/units");
var unitToStyle_1 = require("../internal/unitToStyle");
var Tray_1 = require("../internal/components/Tray");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var faAngleDown_1 = require("@fortawesome/pro-light-svg-icons/faAngleDown");
var faCheck_1 = require("@fortawesome/pro-light-svg-icons/faCheck");
var stateSettings = {
    button: {
        type: 'Object',
        required: false,
        properties: {
            palette: {
                type: 'Object',
                required: false,
                properties: {
                    text: units_1.UNITS.COLOR.asOptional(),
                    background: units_1.UNITS.COLOR.asOptional(),
                    border: units_1.UNITS.COLOR.asOptional()
                }
            }
        }
    },
    checkbox: {
        type: 'Object',
        required: false,
        properties: {
            palette: {
                type: 'Object',
                required: false,
                properties: {
                    check: units_1.UNITS.COLOR.asOptional(),
                    background: units_1.UNITS.COLOR.asOptional(),
                    border: units_1.UNITS.COLOR.asOptional()
                }
            }
        }
    }
};
exports.MultiCheckboxFactory = factory_1.factory({
    name: 'MultiCheckbox',
    settings: {
        tray: Tray_1.traySettings,
        trayItem: Tray_1.trayItemSettings,
        button: {
            type: 'Object',
            properties: {
                padding: units_1.UNITS.PADDING,
                font: units_1.UNITS.FONT,
                border: units_1.UNITS.BORDER.asOptional(),
                angleSpacing: units_1.UNITS.MEASURE,
                angleSize: units_1.UNITS.MEASURE,
                palette: {
                    type: 'Object',
                    properties: {
                        text: units_1.UNITS.COLOR,
                        background: units_1.UNITS.COLOR,
                        border: units_1.UNITS.COLOR.asOptional()
                    }
                }
            }
        },
        checkbox: {
            type: 'Object',
            properties: {
                spacing: units_1.UNITS.MEASURE,
                size: units_1.UNITS.MEASURE,
                border: units_1.UNITS.BORDER.asOptional(),
                palette: {
                    type: 'Object',
                    properties: {
                        check: units_1.UNITS.COLOR,
                        background: units_1.UNITS.COLOR,
                        border: units_1.UNITS.COLOR.asOptional()
                    }
                }
            }
        }
    },
    $when: {
        open: stateSettings,
        active: stateSettings,
        disabled: __assign(__assign({}, stateSettings), { trayItem: Tray_1.trayItemStateSettings.disabled }),
        focus: __assign(__assign({}, stateSettings), { tray: Tray_1.trayStateSettings.focus }),
        hover: __assign(__assign({}, stateSettings), { tray: Tray_1.trayStateSettings.hover, trayItem: Tray_1.trayItemStateSettings.hover })
    },
    component: function (_a) {
        var settings = _a.settings, $when = _a.$when;
        var button = settings.button, tray = settings.tray, trayItem = settings.trayItem, checkbox = settings.checkbox;
        var _b = [Tray_1.makeTray({ settings: tray, $when: $when }), Tray_1.makeTrayItem({ settings: trayItem, $when: $when })], Tray = _b[0], TrayItem = _b[1];
        var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n      display: inline-flex;\n    "], ["\n      position: relative;\n      display: inline-flex;\n    "])));
        var styleButtonByState = function (state) {
            var _a, _b, _c, _d, _e, _f;
            return state !== undefined
                ? styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", "\n            ", "\n            ", "\n          "])), unitToStyle_1.ifDefined('color', (_b = (_a = state.button) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.text), unitToStyle_1.ifDefined('background-color', (_d = (_c = state.button) === null || _c === void 0 ? void 0 : _c.palette) === null || _d === void 0 ? void 0 : _d.background), unitToStyle_1.ifDefined('border-color', (_f = (_e = state.button) === null || _e === void 0 ? void 0 : _e.palette) === null || _f === void 0 ? void 0 : _f.border)) : '';
        };
        var ToggleButton = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      /* Remove default button styling */\n      outline: none;\n      border: 0;\n      padding: 0;\n\n      /* align content */\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      /* Dont wrap lines inside */\n      white-space: nowrap;\n\n      /* Add padding, font and border styling */\n      ", "\n      ", "\n      ", "\n\n      /* Style button in its 'default' state */\n      ", "\n\n      &&[aria-expanded='true'] {\n        ", "\n      }\n\n      &&:disabled {\n        ", "\n      }\n\n      &:focus {\n        ", "\n      }\n\n      &:active {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n    "], ["\n      /* Remove default button styling */\n      outline: none;\n      border: 0;\n      padding: 0;\n\n      /* align content */\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      /* Dont wrap lines inside */\n      white-space: nowrap;\n\n      /* Add padding, font and border styling */\n      ", "\n      ", "\n      ", "\n\n      /* Style button in its 'default' state */\n      ", "\n\n      &&[aria-expanded='true'] {\n        ", "\n      }\n\n      &&:disabled {\n        ", "\n      }\n\n      &:focus {\n        ", "\n      }\n\n      &:active {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n    "])), unitToStyle_1.paddingToStyle(button.padding), unitToStyle_1.fontToStyle(button.font), button.border !== undefined ? unitToStyle_1.borderToStyle(button.border) : '', styleButtonByState(settings), styleButtonByState($when.open), styleButtonByState($when.disabled), styleButtonByState($when.focus), styleButtonByState($when.active), styleButtonByState($when.hover));
        var Angle = styled_components_1.default(react_fontawesome_1.FontAwesomeIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-left: ", ";\n      font-size: ", ";\n    "], ["\n      margin-left: ", ";\n      font-size: ", ";\n    "])), button.angleSpacing, button.angleSize);
        var styleCheckBoxByState = function (state) {
            var _a, _b, _c, _d, _e, _f;
            return state !== undefined
                ? styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            ", "\n            ", "\n          ", "\n          "], ["\n            ", "\n            ", "\n          ", "\n          "])), unitToStyle_1.ifDefined('color', (_b = (_a = state.checkbox) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.check), unitToStyle_1.ifDefined('background-color', (_d = (_c = state.checkbox) === null || _c === void 0 ? void 0 : _c.palette) === null || _d === void 0 ? void 0 : _d.background), unitToStyle_1.ifDefined('border-color', (_f = (_e = state.checkbox) === null || _e === void 0 ? void 0 : _e.palette) === null || _f === void 0 ? void 0 : _f.border)) : '';
        };
        var CheckBox = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      /* Size checkbox */\n      box-sizing: border-box;\n      height: ", ";\n      width: ", ";\n\n      /* Center check inside */\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      /* Add spacing */\n      margin-right: ", ";\n\n      /* Add border if defined */\n      ", "\n\n      /* Style using palette in default state */\n      ", "\n\n      /* Style in all trayItemStates */\n      &:disabled {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n    "], ["\n      /* Size checkbox */\n      box-sizing: border-box;\n      height: ", ";\n      width: ", ";\n\n      /* Center check inside */\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      /* Add spacing */\n      margin-right: ", ";\n\n      /* Add border if defined */\n      ", "\n\n      /* Style using palette in default state */\n      ", "\n\n      /* Style in all trayItemStates */\n      &:disabled {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n    "])), checkbox.size, checkbox.size, checkbox.spacing, checkbox.border !== undefined ? unitToStyle_1.borderToStyle(checkbox.border) : '', styleCheckBoxByState({ checkbox: checkbox }), styleButtonByState($when.disabled), styleButtonByState($when.hover));
        return function (_a) {
            var className = _a.className, disabled = _a.disabled, value = _a.value, onChange = _a.onChange, options = _a.options, children = _a.children;
            var toggleFilter = function (filter) {
                var filterIsOn = value.some(function (f) { return f === filter; });
                onChange(filterIsOn ? value.filter(function (f) { return f !== filter; }) : __spreadArrays([filter], value));
            };
            var _b = downshift_1.useSelect({
                items: options.map(function (o) { return o.value; }),
                stateReducer: function (state, actionAndChanges) {
                    // this prevents the menu from being closed when the user selects an item with 'Enter' or mouse
                    switch (actionAndChanges.type) {
                        case downshift_1.useSelect.stateChangeTypes.MenuKeyDownEnter:
                        case downshift_1.useSelect.stateChangeTypes.ItemClick:
                            toggleFilter(actionAndChanges.changes.selectedItem); // Toggle the filter for the value clicked
                            return __assign(__assign({}, actionAndChanges.changes), { isOpen: state.isOpen, highlightedIndex: state.highlightedIndex // with the item highlighted.
                             });
                        default:
                            return actionAndChanges.changes; // otherwise business as usual.
                    }
                }
            }), isOpen = _b.isOpen, getToggleButtonProps = _b.getToggleButtonProps, getMenuProps = _b.getMenuProps, getItemProps = _b.getItemProps;
            return (react_1.default.createElement(Container, { className: className },
                react_1.default.createElement(ToggleButton, __assign({ disabled: disabled }, getToggleButtonProps()),
                    children,
                    " ",
                    react_1.default.createElement(Angle, { icon: faAngleDown_1.faAngleDown })),
                react_1.default.createElement(Tray, __assign({}, getMenuProps(), { isOpen: isOpen }), isOpen &&
                    options.map(function (item, index) {
                        var itemProps = getItemProps({ item: item.value, index: index });
                        var active = value.some(function (f) { return item.value === f; });
                        return (react_1.default.createElement(TrayItem, __assign({ key: item.value }, itemProps),
                            react_1.default.createElement(CheckBox, { "aria-selected": active || itemProps['aria-selected'] }, active && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCheck_1.faCheck })),
                            item.label));
                    }))));
        };
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
